import { isResource } from '@medplum/core'
import type { Medication } from '@medplum/fhirtypes'
import { codeFromCodeableConcept } from '#src/codeableConcept.ts'
import { ExtendedResource } from '#src/ExtendedResource.ts'
import { isOfType } from '#src/utils.ts'

export class ExtendedMedication extends ExtendedResource<Medication> {
  static readonly RESOURCE_TYPE = 'Medication'

  static isInstance(value: unknown): value is Medication {
    return isResource(value) && isOfType(value, 'Medication')
  }

  get status(): Medication['status'] {
    return this.resource.status
  }

  get code(): string | undefined {
    return codeFromCodeableConcept(this.resource.code)
  }

  get formCode(): string | undefined {
    return codeFromCodeableConcept(this.resource.form)
  }

  get manufacturerDisplay(): string {
    return this.resource.manufacturer?.display ?? ''
  }

  get amountValue(): number | undefined {
    return this.resource.amount?.numerator?.value
  }

  get amountUnit(): string | undefined {
    return this.resource.amount?.numerator?.unit
  }

  get lotNumber(): string | undefined {
    return this.resource.batch?.lotNumber
  }

  get expirationDate(): string | undefined {
    return this.resource.batch?.expirationDate
  }

  get ingredients(): string[] | undefined {
    return this.resource.ingredient?.map(
      (i) =>
        `${codeFromCodeableConcept(i.itemCodeableConcept)}: ${i.strength?.numerator?.value ?? ''} ${i.strength?.numerator?.unit ?? ''}`
    )
  }

  protected getExportFields() {
    return {
      id: this.id,
      status: this.status,
      code: this.code,
      form: this.formCode,
      manufacturer: this.manufacturerDisplay,
      amountValue: this.amountValue,
      amountUnit: this.amountUnit,
      lotNumber: this.lotNumber,
      expirationDate: this.expirationDate,
      ingredients: this.ingredients,
    }
  }
}
